import {
  CoolblueEnergyChip,
  EducationChip,
  HoursChip,
  InternalChip,
  SalaryChip
} from '@components/Chips';
import { CbShadowSubtle } from '@coolblue-development/design-tokens';
import { ChipGroup } from '@coolblue-development/freddy';
import { type ChipUSPs as ChipUSPsType } from '@sharedTypes';

import { LocationSelector } from './LocationSelector';
import { RelocationChipModal } from './RelocationChipModal';

type Props = {
  chipUSPs: ChipUSPsType;
};

export const ChipUSPs = ({ chipUSPs }: Props) => {
  return (
    <ChipGroup
      size={{ xs: 'small', md: 'medium' }}
      sx={{ '> span': { boxShadow: CbShadowSubtle } }}
    >
      {chipUSPs.isInternal && <InternalChip />}
      {chipUSPs.relocationPossible && <RelocationChipModal />}
      <LocationSelector locations={chipUSPs.locations} currentLocation={chipUSPs.location} />
      {chipUSPs.hours && <HoursChip hours={chipUSPs.hours} />}
      <SalaryChip salaryValue={chipUSPs.salaryValue} salaryRange={chipUSPs.salaryRange} />
      <EducationChip educationLevels={chipUSPs.educationLevels} />
      {chipUSPs.isCoolblueEnergy && <CoolblueEnergyChip />}
    </ChipGroup>
  );
};
